import React from "react";
import { Select } from "antd";
import { Checkbox } from "Shared/ui";

import { PlusIcon, TrashCanIcon } from "Shared/icons";
import { methodController } from "../lib/withdraw_method_controller";
import "./withdraw_method.widget.scss";

export const WithdrawMethodWidget = () => {
	const {
		methods = [],
		onSelectMethod,
		onSelectWallet,
		wallets = [],
		selectedWallet,
		selectedMethod,
		onShowModal,
		onDeleteWallet,
	} = methodController();

	const accountName = selectedMethod === "paypal" ? "PayPal account" : "IBAN account";
	const addText = selectedMethod === "paypal" ? "Add new PayPal" : "Add new IBAN";
	return (
		<div className="w-m">
			<div className="w-m__text_s mb-10">Paying method</div>
			<div className="w-m__select mb-20">
				<Select value={selectedMethod} options={methods} onChange={onSelectMethod} />
			</div>
			{!!selectedMethod && (
				<>
					<div className="w-m__text_l mb-10">{accountName}</div>
					{wallets.map((wallet) => {
						const onSelect = () => onSelectWallet(wallet);
						const isChecked = wallet.name === selectedWallet?.name;
						return (
							<div key={wallet.id} className={"w-m__wallet"}>
								<div className={"w-m__wallet-number"}>
									<Checkbox shape="circle" checked={isChecked} onChange={onSelect} label={wallet.name} />
								</div>
								<div style={{ minWidth: 16 }} onClick={() => onDeleteWallet(wallet.id)}>
									<TrashCanIcon />
								</div>
							</div>
						);
					})}

					<div className="w-m__add" onClick={onShowModal}>
						<div className="mr-15">
							<PlusIcon />
						</div>
						<span className="w-m__text_m w-m__text_orange">{addText}</span>
					</div>
				</>
			)}
		</div>
	);
};
